<template>
<v-container fluid fill-height>
    <loading v-if="loading"></loading>
    <v-layout v-else>
        <v-flex>
            <v-card>
                <v-layout pa-2>
                    <v-layout column>
                        <v-layout>
                            <v-flex xs12>
                                <h1 class="text-xs-center">Profile Templates</h1>
                            </v-flex>
                        </v-layout>
                        <forecast-profiles :forecastProfiles="forecastProfiles" @ReloadData="loadData">
                        </forecast-profiles>
                    </v-layout>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import Loading from '@/components/generic/Loading.vue';
import ForecastProfiles from '@/components/forecasting/ForecastProfiles.vue';

export default {
    components: {
        Loading,
        ForecastProfiles
    },
    data() {
        return {
            loading: false
        };
    },
    computed: {
        forecastProfiles() {
            return this.$store.getters["ForecastingProfileStore/getForecastProfiles"]({});
        },
        plantID() {
            return this.$route.params.plantID;
        }
    },
    methods: {
        async loadData() {
            this.loading = true;

            await this.$store.dispatch("ForecastingProfileStore/loadPlantProfileTemplatesAsync", {
                plantID: this.plantID
            });

            this.loading = false;
        }
    },
    created() {
        this.loadData();
    }
}
</script>

<style>

</style>
